import { z } from "zod";

export const RegisterEmployeeFormSchema = z.object({
  vocation_id: z.array(z.string()).min(1, "Selecione pelo menos uma profissão"),
  user_id: z.string().uuid({ message: "Usuário inválido" }),
  name: z.string().min(3, { message: "Nome inválido" }),
  whatsapp: z
    .string()
    .min(13, {
      message: "Whatsapp inválido",
    })
    .max(13, {
      message: "Whatsapp inválido",
    }),
});
